import { BalanceThreshold } from "../Balance.types";

export const BALANCE_THRESHOLDS: BalanceThreshold[] = [
    {
        value: 100000000,
        decimals: 0,
    },
    {
        value: 10000000,
        decimals: 1,
    },
    {
        value: 100,
        decimals: 2,
    },
    {
        value: 1,
        decimals: 4,
    },
    {
        value: 0.00001,
        decimals: 6,
    },
];
